module.exports = __webpack_public_path__ + "img/header.a30b1a5c.png";